<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: The Power of Pooping, by Susan Wong" aria-describedby="cover-alt" class="imagefp" role="doc-cover" src="e9781646042845/images/9781646042845.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>Nurse Wong from Butt Talks TV with John Rietcheck</p>
<p>The Power of Pooping</p>
<p>A Cheeky Diet and Lifestyle Guide to End Constipation and Transform Your Health</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?761473d3